import { Box, Button, Divider, Typography, Link } from '@mui/material';
import AFForm594Instructions from '../static/AF Form 594 - TLA Instruction.pptx';
import TLADailyRatesJan6th from '../static/TLA Daily Rate 6 Jan 22.pdf';
import TLADailyRatesRecent from '../static/TLA Daily Rates-Dec 17th-Jan 5th.pdf';
import TLADailyRatesOld from '../static/TLADailyRatesUntilDec16.pdf';
import AF594 from '../static/AF594.pdf';
import TLAProcessingGuidance from '../static/Air Force Temporary Lodging Allowance Information Paper - All AF Claims.pdf';
import FlushingPlan from '../static/Claims Process for Personal Property Damage - JBPHH (Final 9 Dec 21) (003).pdf';
import CivilianPersonnelChecklist from '../static/1 - Civilian Personnel Checklist.pdf';
import EvacuationInformationVerification from '../static/2 - Evacuation Information Verification Sheet.pdf';
import EvacuationDependentCert from '../static/3 - Evacuation Dependent Certification.pdf';
import EvacuationLodgingCert from '../static/4 - Evacuation Lodging Certification Sheet.pdf';
import DAFCivilainEmployees from '../static/DAF Civilian Employees - Evacuation Orders and Travel Voucher Guidance.pdf';
import NavyHousingInfoGraphic from '../static/navyhousinginfographic.png';
import TLAFilingIncrements from '../static/Dept AF - TLA Filing Increments.pdf'

const Resources = () => {
  return (
    <Box sx={{ padding: '0 30px' }} aria-label='forms'>
      <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
        Air Force Members who have chosen to stay in place and would like to
        claim TLA must complete the AF Form 594 and bring it to the Hickam Base
        Theater filled out. Please take the following information into
        consideration:
      </Typography>
      <ul>
        <li>
          Special Power of Attorney (SPOA) is required if dependent is
          requesting TLA reimbursement on behalf of their family, due to their
          sponsor being deployed or unavailable. Please bring this documentation
          to the Hickam Base Theater along with the filled-out AF Form 594
        </li>
        <li>Proof of address (POA) is no longer a required item.</li>
      </ul>

      <Typography sx={{ fontWeight: 'bold' }} variant='body1'>
        Forms to Fill Out:
      </Typography>
      <Box
        sx={{ width: '100%', textDecoration: 'none' }}
        component='a'
        href={AF594}
        download
      >
        <Button sx={{ padding: '10px', textAlign: 'left' }}>AF Form 594</Button>
      </Box>
      <Divider />
      <Typography
        sx={{ paddingTop: '10px', fontWeight: 'bold' }}
        variant='body1'
      >
        How to fill out the AF Form 594:
      </Typography>
      <Box
        sx={{ width: '100%', textDecoration: 'none' }}
        component='a'
        href={AFForm594Instructions}
        download
      >
        <Button sx={{ padding: '10px', textAlign: 'left' }}>
          AF Form 594 - TLA Instructional Powerpoint
        </Button>
      </Box>
      <Divider />
      <Typography
        sx={{ paddingTop: '10px', fontWeight: 'bold' }}
        variant='body1'
      >
        Additional Guidance/Regulations:
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{ width: '100%', textDecoration: 'none' }}
          component='a'
          href={TLADailyRatesJan6th}
          download
        >
          <Button sx={{ padding: '10px', textAlign: 'left' }}>
            TLA Daily Rates (Jan 6th)
          </Button>
        </Box>
        <Box
          sx={{ width: '100%', textDecoration: 'none' }}
          component='a'
          href={TLADailyRatesRecent}
          download
        >
          <Button sx={{ padding: '10px', textAlign: 'left' }}>
            TLA Daily Rates (Dec 17th-Jan 5th)
          </Button>
        </Box>
        <Box
          sx={{ width: '100%', textDecoration: 'none' }}
          component='a'
          href={TLADailyRatesOld}
          download
        >
          <Button sx={{ padding: '10px', textAlign: 'left' }}>
            TLA Daily Rates (Dec 3rd-Dec 16th)
          </Button>
        </Box>
        <Box
          sx={{ width: '100%', textDecoration: 'none' }}
          component='a'
          href={TLAProcessingGuidance}
          download
        >
          <Button sx={{ padding: '10px' }}>TLA Processing Guidance</Button>
        </Box>
        <Box
          sx={{ width: '100%', textDecoration: 'none' }}
          component='a'
          href={FlushingPlan}
          download
        >
          <Button sx={{ padding: '10px', textAlign: 'left' }}>
            AF Claims Process For Personal Property Damage
          </Button>
        </Box>
        <Box sx={{ width: '100%', textDecoration: 'none' }} component='a'>
          <Button sx={{ textAlign: 'left' }}>
            <Link
              color='inherit'
              href='https://www.cpf.navy.mil/JBPHH-Water-Updates/fbclid/IwAR0ui_VwkxfjB2X-TOLL46f5B4EPT8OdgX10HITbKX_eJJmFYptKaVJrXtM/#flushing-plan'
              underline='none'
            >
              Water System Flushing Zones (projected dates subject to change)
            </Link>
          </Button>
        </Box>
        <Box
          sx={{ width: '100%', textDecoration: 'none' }}
          component='a'
          href={TLAFilingIncrements}
          download
        >
          <Button sx={{ padding: '10px' }}>Dept of the Air Force TLA Filing Increments</Button>
        </Box>
      </Box>
      <Divider />
      <Typography
        sx={{ paddingTop: '10px', fontWeight: 'bold' }}
        variant='body1'
      >
        DAF Civilian Evacuation Order Forms:
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{ width: '100%', textDecoration: 'none' }}
          component='a'
          href={DAFCivilainEmployees}
          download
        >
          <Button sx={{ padding: '10px', textAlign: 'left' }}>
            DAF Civilian Guidance For Evacuation Orders and Travel Vouchers
          </Button>
        </Box>
        <Box
          sx={{ width: '100%', textDecoration: 'none' }}
          component='a'
          href={NavyHousingInfoGraphic}
          download
        >
          <Button sx={{ padding: '10px', textAlign: 'left' }}>
            Federal/Non-Federal Civilians in Navy Housing (Remained at Home)
            Federal Assistance
          </Button>
        </Box>
        <Box
          sx={{ width: '100%', textDecoration: 'none' }}
          component='a'
          href={CivilianPersonnelChecklist}
          download
        >
          <Button sx={{ padding: '10px', textAlign: 'left' }}>
            DAF Civilian Personnel Checklist
          </Button>
        </Box>
        <Box
          sx={{ width: '100%', textDecoration: 'none' }}
          component='a'
          href={EvacuationInformationVerification}
          download
        >
          <Button sx={{ padding: '10px', textAlign: 'left' }}>
            DAF Civilian Evacuation Information Verification
          </Button>
        </Box>
        <Box
          sx={{ width: '100%', textDecoration: 'none' }}
          component='a'
          href={EvacuationDependentCert}
          download
        >
          <Button sx={{ padding: '10px', textAlign: 'left' }}>
            DAF Civilian Evacuation Dependent Certification
          </Button>
        </Box>
        <Box
          sx={{ width: '100%', textDecoration: 'none' }}
          component='a'
          href={EvacuationLodgingCert}
          download
        >
          <Button sx={{ padding: '10px', textAlign: 'left' }}>
            DAF Civilian Evacuation Lodging Certification
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export { Resources };
